module.exports = __webpack_public_path__ + "media/images/flags/32/Unknown-a6fddc4c9d890408e5754027cf76c6ce.png";